/**
 * Component Contexts for BMW Header
 * 
 * @author jjarolim
 */

import { createContext } from '@lit/context'
import type { Breakpoint, MenuItem } from '../../shared'

/* Context for navigation */

const navigationContextKey = Symbol('context-navigation')
type NavigationContextValue = MenuItem[]
const navigationContext = createContext<NavigationContextValue>(navigationContextKey)

/* Context for display mode */

const displayModeContextKey = Symbol('context-display-mode')
type DisplayModeContextValue = string
const displayModeContext = createContext<DisplayModeContextValue>(displayModeContextKey)

/* Context for current breakpoint */

const breakpointContextKey = Symbol('context-breakpoint')
type BreakpointContextValue = Breakpoint
const breakpointContext = createContext<BreakpointContextValue>(breakpointContextKey)

/* Context for is menu open */

const isSubMenuOpenContextKey = Symbol('context-is-menu-open')
type IsSubMenuOpenContextValue = boolean
const isSubMenuOpenContext = createContext<IsSubMenuOpenContextValue>(isSubMenuOpenContextKey)

/* Context for is outlet navigation open */

const isOutletNavigationOpenContextKey = Symbol('context-is-outlet-navigation-open')
type IsOutletNavigationOpenContextValue = boolean
const isOutletNavigationOpenContext = createContext<IsOutletNavigationOpenContextValue>(isOutletNavigationOpenContextKey)


/* Context for is scrolled top */

const isScrolledTopContextKey = Symbol('context-is-scrolled-top')
type IsScrolledTopContextValue = boolean
const isScrolledTopContext = createContext<IsScrolledTopContextValue>(isScrolledTopContextKey)

export { 
    breakpointContext,
    breakpointContextKey,
    type BreakpointContextValue,
    displayModeContext, 
    displayModeContextKey, 
    type DisplayModeContextValue,
    isOutletNavigationOpenContext,
    isOutletNavigationOpenContextKey,
    type IsOutletNavigationOpenContextValue,
    isSubMenuOpenContext,
    isSubMenuOpenContextKey,
    type IsSubMenuOpenContextValue,
    isScrolledTopContext,
    isScrolledTopContextKey,
    type IsScrolledTopContextValue,
    navigationContext, 
    navigationContextKey, 
    type NavigationContextValue, 
}